import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { DateHeading as BaseDateHeading } from '@mews-distributor/ui';
import { showDates } from '../../actions/navigation';
import { getParsedEndDate, getParsedStartDate } from '../../modules/resourceOrder/selectors';

export const DateHeading = connect(
    // @ts-expect-error $TSFixMeError: No overload matches this call.
    createStructuredSelector({
        startDate: getParsedStartDate,
        endDate: getParsedEndDate,
    }),
    {
        onClick: showDates,
    }
)(BaseDateHeading);
